import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { QontoService } from 'src/app/services/qonto.service';

@Component({
  selector: 'app-qonto-callback',
  templateUrl: './qonto-callback.component.html',
  styleUrls: ['./qonto-callback.component.scss']
})
export class QontoCallbackComponent implements OnInit {

  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private qontoService: QontoService,
    private commanUsesService: CommanUsesService,
  ) { }

  async ngOnInit() {
    try {
      this.route.queryParams.subscribe(async (params) => {
        this.queryParams = params; 
        const code = params['code'];
        console.log("this.queryParams", this.queryParams); 
        console.log("code", code);
        if(code) {
          let result = await this.qontoService.generateTokens(code);
          console.log("RESULT", result);
          if(result?.qontoRefreshToken && result?.qontoAccessToken) {
            this.commanUsesService.showSnackBar("CONNECTED_WITH_QONTO");
            this.router.navigate(['/profilo']);
          } else {
            this.commanUsesService.showSnackBar("SOMETHING_WENT_WRONG");
            this.router.navigate(['/profilo']);
          }
        }
      });
    } catch (error) {
      this.commanUsesService.showSnackBar(`SOMETHING_WENT_WRONG  ${error?.error?.message}`);
    }
  }

}
